import React, { useState, useEffect } from 'react';
import { aiAgents, agentCategories } from '../agentData';
import { getSettingsSync } from '../utils/settings';
import './Agents.css';

const Agents = () => {
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [settings, setSettings] = useState(getSettingsSync());

  useEffect(() => {
    const loadSettings = async () => {
      const { getSettings } = await import('../utils/settings');
      const fetchedSettings = await getSettings();
      setSettings(fetchedSettings);
    };
    loadSettings();
    
    const handleSettingsUpdate = () => {
      loadSettings();
    };
    
    window.addEventListener('settingsUpdated', handleSettingsUpdate);
    return () => window.removeEventListener('settingsUpdated', handleSettingsUpdate);
  }, []);

  const filteredAgents = selectedCategory === 'all'
    ? aiAgents
    : aiAgents.filter(agent => agent.category === selectedCategory);

  return (
    <div className="agents-page">
      <section className="page-hero">
        <h1 className="display-huge">{settings.agentsHeroTitle}</h1>
        <p className="body-large" style={{ marginTop: '32px', maxWidth: '900px', margin: '32px auto 0' }}>
          {settings.agentsHeroDescription}
        </p>
      </section>

      {/* Category Filter */}
      <section className="category-filter-section">
        <div className="category-filter">
          <button
            className={`category-btn ${selectedCategory === 'all' ? 'active' : ''}`}
            onClick={() => setSelectedCategory('all')}
          >
            All Agents ({aiAgents.length})
          </button>
          {agentCategories.map((category) => {
            const count = aiAgents.filter(a => a.category === category.id).length;
            return (
              <button
                key={category.id}
                className={`category-btn ${selectedCategory === category.id ? 'active' : ''}`}
                onClick={() => setSelectedCategory(category.id)}
              >
                {category.name} ({count})
              </button>
            );
          })}
        </div>
      </section>

      {/* Agents Grid */}
      <section className="agents-grid-section">
        <div className="agents-grid-full">
          {filteredAgents.map((agent) => {
            const category = agentCategories.find(cat => cat.id === agent.category);
            return (
              <div
                key={agent.id}
                className="agent-card-full dark-hover"
              >
                <div className="agent-card-image-full" style={{ backgroundImage: `url(${agent.image})` }}></div>
                <div className="agent-card-content-full">
                  <div className="category-tag-small">{category?.name}</div>
                  <h3 className="heading-2" style={{ marginTop: '12px' }}>{agent.name}</h3>
                  <p className="body-medium" style={{ marginTop: '16px' }}>{agent.description}</p>
                  <div className="workflows-section" style={{ marginTop: '20px' }}>
                    <p className="body-small" style={{ color: 'var(--text-muted)', marginBottom: '8px' }}>Key Workflows:</p>
                    <div className="workflow-tags-grid">
                      {agent.workflows.slice(0, 3).map((workflow, idx) => (
                        <span key={idx} className="workflow-tag-small">{workflow}</span>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </section>
    </div>
  );
};

export default Agents;